import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AuthService } from "../services/auth.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    // Não injeta token em requests de login
    if (request.url.indexOf("/api/Auth/login") !== -1) {
      return next.handle(request);
    }

    const user = this.authService.getUser();
    if (user?.jwtToken?.token) {
      const headers: Record<string, string> = {
        Authorization: `Bearer ${user.jwtToken.token}`,
      };

      // Envia o contratante selecionado para o backend
      if (user.contractorId) {
        headers['X-Contractor-Id'] = user.contractorId.toString();
      }

      request = request.clone({ setHeaders: headers });
    }

    return next.handle(request);
  }
}
